<template>
  <div
    id="upcoming-event-banner"
    class="bg-gray-200 organism upcoming-event-banner"
  >
    <div
      class="flex flex-wrap items-center justify-center py-4 pl-3 mx-auto text-center md:justify-start md:text-left max-w-7xl gap-3"
    >
      <StarIcon class="w-5 h-5 text-gray-900 stroke-white" aria-hidden="true" />
      <h2 class="font-archer font-semibold text-[25px] text-white leading-none">
        Join us for an upcoming event!
      </h2>
      <NuxtLink
        :to="organism.uri"
        :title="organism.title"
        class="rounded shadow bg-amber-400 font-ubuntu font-medium text-[13px] px-4 py-1"
        >Learn More</NuxtLink
      >
    </div>
  </div>
</template>

<style>
#upcoming-event-banner {
  background-image: linear-gradient(101deg, #367ea0 0%, #4dadce 97%);
}
</style>

<script setup>
import { StarIcon } from "@heroicons/vue/outline/index.js";
const props = defineProps({
  organism: Object,
});
</script>
